<template>
    <div class="ds-status-chip" :class="[{ 'ds-status-chip-closed': status?.value === 'completed' }, { 'ds-status-chip-rejected': status?.value === 'rejected' }, { 'ds-status-chip-waiting': status?.value === 'requested' }]">
        {{ status?.name }}
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useExchangeStore } from '@/stores/exchangeStore'

const store = useExchangeStore()

const props = defineProps(['status'])   
const status = computed(() => store.requestStatuses.find(item => item.value === props.status ))
</script>
